import { gql } from '@apollo/client';
import { TaskPreviewGetFunnelsAndConfig_vm_enrolActivity as ConfigFlag } from './__generated__/TaskPreviewGetFunnelsAndConfig';

const CONFIG_FLAG_FRAGMENT = gql`
  fragment TaskPreviewConfigFlag on ConfigItemType {
    configItemId
    key
    defaultValue
    configItemValue {
      flagValue
    }
  }
`;

export const TASK_PREVIEW_GET_FUNNELS_AND_CONFIG = gql`
  query TaskPreviewGetFunnelsAndConfig {
    vm {
      funnels {
        funnelId
        name
        isActive
        lockPrograms
        lockActivities
        lockRoles
        showTaskList
        programs {
          programId
          name
        }
        activities {
          activityId
          name
        }
        activityRoles {
          activityRoleId
          name
        }
      }
      enrolActivity: configItem(key: "application-enrol-activity") {
        ...TaskPreviewConfigFlag
      }
      applyRole: configItem(key: "application-apply-role") {
        ...TaskPreviewConfigFlag
      }
      multiProgram: configItem(key: "allow-multi-program-application") {
        ...TaskPreviewConfigFlag
      }
    }
  }
  ${CONFIG_FLAG_FRAGMENT}
`;

export const resolveConfigFlag = (flag?: ConfigFlag | null): boolean =>
  flag?.configItemValue?.flagValue ?? flag?.defaultValue ?? false;
